// OGS decoder precision — fp16 = 16-bit weights, fp32 = 32-bit. The OGS Avatar
// blueprint node picks it; OGSModel reads the pick and configures the runner.
// Pure + tiny so the mapping is unit-tested without ORT or the editor.

export const OGS_PRECISION_FP16 = 'fp16'
export const OGS_PRECISION_FP32 = 'fp32'
export const DEFAULT_OGS_PRECISION = OGS_PRECISION_FP16

const AVATAR_NODE_TYPE = 'plugin.ogs.avatar'

// Human label for the dropdown option + node readout.
export function precisionLabel(p) {
  return p === OGS_PRECISION_FP32 ? '32-bit (fp32)' : '16-bit (fp16)'
}

// fp16 is preferred unless the pick is fp32. The runner still auto-downgrades
// fp16→fp32 when the adapter can't build it — this is only the request.
export function precisionPrefersFp16(p) {
  return p !== OGS_PRECISION_FP32
}

// Read the OGS Avatar node's precision pick from a face-graph node list,
// falling back to the default when the node or field is absent.
export function readAvatarPrecision(nodes) {
  const node = Array.isArray(nodes) ? nodes.find(n => n?.type === AVATAR_NODE_TYPE) : null
  const p = node?.data?.precision
  return p === OGS_PRECISION_FP32 || p === OGS_PRECISION_FP16 ? p : DEFAULT_OGS_PRECISION
}
